import React from 'react'
import css from '../TwoColumns.module.css'

interface SecondaryColumnProps {
  children: React.ReactNode
}

const SecondaryColumn = ({ children }: SecondaryColumnProps) => (
  <aside className={css.wrapperSecondary}>
    {children}
  </aside>
)

export { SecondaryColumn }
